import $ from "jquery";

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height() + 100;
    return elementTop > viewportTop && elementBottom < viewportBottom;
};

 

$(window).on('resize scroll', function () {
    if (window.matchMedia('(max-width: 767px)').matches) {
        $('.sectionImagesColumn').each(function () {
            if ($(this).isInViewport()) {
                $(this).find('.sectionImagesColumn-overlay').css({
                    'opacity': '1',
                    'visibility': 'visible'
                });
            } else {
                $(this).find('.sectionImagesColumn-overlay').css({
                    'opacity': '0',
                    'visibility': 'hidden'
                });
            }
        });
        $('.sectionImage').each(function () {
            if ($(this).isInViewport()) {
                $(this).find('.sectionImage-overlay').css({
                    'opacity': '1',
                    'visibility': 'visible'
                });
            } else {
                $(this).find('.sectionImage-overlay').css({
                    'opacity': '0',
                    'visibility': 'hidden'
                });
            }
        });
    }
});
